import { Action, IOWidget, mk_widget } from 'widgets-for-react'
import React from 'react'
import { CMSState } from '../../../../cms/blocks/types.gen'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { NavLink } from 'react-router-dom'
import { WordPress } from '../../../../wordpress/wordpress_api'

type displayLatesUpdates = { kind: 'latest' }
type displaySelectedUpdates = { kind: 'selected'; ids: Array<number> }
import { PublicSiteState } from '../../../../public_site.main.mod'
import { toRelativeUrl } from '../../../../../helpers'
import * as Moment from 'moment'
import { getImageSize } from '../../../utils/extra_images.mod'

export type LatestBlockProps = {
  title: string
  hasBackground?: boolean
  button?: {
    title: string
    url: string
  }
  display: displayLatesUpdates | displaySelectedUpdates

  show_in_page_navigation: boolean
  navigation_title: string
}

export type UpdateProps = {
  title: string
  date?: string
  image?: WordPress.Image
  url: string
  key?: number
}

export type LatestBlockStyle = Partial<{}>

export function LatestBlock<CustomBlockData, extra_images>(
  props: LatestBlockProps,
  options?: { style?: LatestBlockStyle; key?: string }
): (
    s: CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>
  ) => IOWidget<PublicSiteState, Action<CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (s: CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) =>
    mk_widget({
      run: onDone => (
        <section
          id={props.navigation_title}
          className={`block block--grid block--updates${props.hasBackground ? '' : ''}`}>
          <div className="block__inner container container--l grid--block">
            <header className="block__header block__header--icon">
              <h2 className="block__title typo--l">{props.title}</h2>
              {props.button && props.button.title && props.button.url && (
                <footer className="block__footer">
                  <NavLink
                    className={`btn btn--tertiary ${props.hasBackground ? '' : ''}`}
                    to={props.button.url}
                  >
                    {props.button.title}
                  </NavLink>
                </footer>
              )}
            </header>

            <ul className="block--updates__content c--columns">
              {props.display.kind == 'selected' ? (
                public_state.latest_updates.kind == 'loaded' && public_state.latest_updates.value.slice(0, 3).map((update, index) => (
                  <Update
                    title={update.title.rendered}
                    image={update.featured_media}
                    date={update.date ? update.date : null}
                    url={update.link}
                    key={update.id}
                  />
                ))
              ) : public_state.latest_updates.kind == 'loaded' && public_state.latest_updates.value.slice(0, 3).map((update, index) => (
                <Update
                  title={update.title.rendered}
                  image={update.featured_media}
                  date={update.date ? update.date : null}
                  url={update.link}
                  key={update.id}
                />
              ))
              }
            </ul>
          </div>
        </section>
      )
    })
}

export function Update(props: UpdateProps): JSX.Element {
  return (
    <li className="grid__item item">
      <article className="grid__article">
        <NavLink className="grid__inner grid__link grid__link--image" to={toRelativeUrl(props.url)}>
          <div className="grid__content grid__content--image">
            <header className="grid__header">
              <h3 className="grid__title typo--m" dangerouslySetInnerHTML={{ __html: props.title }}></h3>

              {props.date && <time className="grid__date" date-time={Moment.default(props.date).format('DD-MM-YYYY')}>{Moment.default(props.date).format('DD-MM-YYYY')}</time>}
            </header>
            <svg
              className="grid__icon grid__icon--text"
              width="25px"
              height="14px"
              aria-hidden="true"
            >
              <use xlinkHref="#icon--arrow" />
            </svg>
          </div>

          {props.image && (
            <div className="grid__visual">
              <img
                src={getImageSize(props.image, '1320x765')}
                data-src={getImageSize(props.image, '440x255')}
                data-srcset={[
                  [getImageSize(props.image, '440x255') + ' 440w'],
                  [getImageSize(props.image, '880x510') + ' 880w'],
                  [getImageSize(props.image, '1320x765') + ' 1320w'],
                ]}
                data-sizes="auto"
                width="440"
                height="255"
                className="grid__image"
                alt={props.title} />
            </div>
          )}
        </NavLink>
      </article>
    </li>
  )
}



// WEBPACK FOOTER //
// ./Client/components/public_site/blocks/custom_blocks/widgets/latestBlock.tsx